var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.058,
    cy: 20.46,
    r: 20,
    fill: "#7C7C7C"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.058,
    cy: 14.623,
    r: 6,
    fill: "#C1C1C1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.058 27.758c0 4.03-1.5 3.82-9 3.82-7.501 0-9 .21-9-3.82s4.029-7.298 9-7.298c4.97 0 9 3.267 9 7.298z",
    fill: "#C1C1C1"
  })));
}
export default SvgAvatar;